import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Icon, Loader, Message } from 'semantic-ui-react';
import MinimumSpendMonitor from './minimum-spend-monitor.js';
import EquipmentCard from './equipment-card.js';
import EquipmentProductList from './equipment-product-list.js';
import EquipmentVendorProducts from './equipment-vendor-products.js';
import { doGetEquipment } from '../../actions/equipment-actions.js';
import './equipment-page.css';

export class EquipmentPage extends React.PureComponent {
  componentDidMount() {
    if (this.props.locationId) {
      this.props.actions.doGetEquipment({
        location_id: this.props.locationId,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.locationId !== this.props.locationId &&
      this.props.locationId
    ) {
      this.props.actions.doGetEquipment({
        location_id: this.props.locationId,
      });
    }
  }

  render() {
    const { items, loading, error } = this.props;

    return (
      <div className="equipment-page">
        {items.length > 0 && (
          <div className="equipment-service-cta">
            <div className="equipment-service-cta-text">
              <strong>Need equipment serviced?</strong>
              <span>Submit a service request and we'll take care of it.</span>
            </div>
            <Link to="/equipment/service-request" className="equipment-service-cta-btn">
              Request Service
            </Link>
          </div>
        )}
        {loading && !items.length ? (
          <Loader active inline="centered" />
        ) : error && !items.length ? (
          <Message negative icon>
            <Icon name="warning sign" />
            <Message.Content>
              <Message.Header>Unable to load equipment</Message.Header>
              <p>Something went wrong. Please try again later.</p>
            </Message.Content>
          </Message>
        ) : !items.length ? (
          <p className="equipment-empty">
            No equipment found at this location.
          </p>
        ) : (
          <>
            <div className="equipment-main">
              <div className="equipment-left">
                <hr className="equipment-divider" />
                <h3 className="equipment-heading">Your Equipment</h3>
                <div className="equipment-cards-scroll">
                  <div className="equipment-cards-grid">
                    {items.map((eq) => (
                      <EquipmentCard key={eq.id} equipment={eq} />
                    ))}
                  </div>
                </div>
              </div>
              <div className="equipment-right">
                <hr className="equipment-divider" />
                <h3 className="equipment-heading">Minimum Spend Monitor</h3>
                <MinimumSpendMonitor />
              </div>
            </div>
            <hr className="equipment-divider" />
            <h2 className="equipment-heading">Suggested Products To Hit Minimum Spend</h2>
            <div className="equipment-product-lists">
              {items.filter((eq) => eq.equipment_product_list_id).map((eq) => (
                <EquipmentProductList
                  key={eq.id}
                  equipmentId={eq.id}
                  equipmentName={eq.model_name}
                />
              ))}
            </div>
            <EquipmentVendorProducts />
          </>
        )}
      </div>
    );
  }
}

EquipmentPage.propTypes = {
  locationId: PropTypes.number,
  items: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    doGetEquipment: PropTypes.func.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    locationId: state.locations.open.id,
    items: state.equipment.items,
    loading: state.equipment.loading,
    error: state.equipment.error,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ doGetEquipment }, dispatch),
  };
}

function areStatesEqual(prev, next) {
  return (
    prev.equipment.items === next.equipment.items &&
    prev.equipment.loading === next.equipment.loading &&
    prev.equipment.error === next.equipment.error &&
    prev.equipment.minimumSpend === next.equipment.minimumSpend &&
    prev.locations.open.id === next.locations.open.id
  );
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  areStatesEqual,
})(EquipmentPage);
